import { render, staticRenderFns } from "./InboxLetters.vue?vue&type=template&id=05cdec2f"
import script from "./InboxLetters.vue?vue&type=script&lang=js"
export * from "./InboxLetters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports